import { CalendarIcon, DownArrowIcon } from "@xola/icons";
import { DatePickerPopover } from "@xola/ui-kit";
import { DateFormat, formatDate } from "common";
import dayjs from "dayjs";
import React from "react";
import shallow from "zustand/shallow";
import { ListFilter } from "../Filters/ListFilter";
import { MERCHANDISE_API_PATH } from "@/models/Merchandise";
import { useDashboardFilterStore } from "@/stores/dashboardFilterStore";
import {
    MerchandiseDashboardFulfillmentFilter,
    useMerchandiseDashboardStore,
} from "@/stores/merchandiseDashboardStore";

export const MerchandiseDashboardFilters = () => {
    const [date, setDate] = useDashboardFilterStore((state) => [state.date, state.setDate], shallow);
    const [filters, setFilters] = useMerchandiseDashboardStore(
        (state) => [state.filters, state.actions.setFilters],
        shallow,
    );

    const handleDateChange = (newDate: Date) => {
        setDate(dayjs(newDate));
    };

    const dateValue = formatDate(date.toDate(), DateFormat.DATE_MONTH);

    return (
        <div className="w-full divide-y divide-gray-lighter">
            <div className="flex w-full items-center space-x-2 py-2 px-6 xl:px-10">
                <div className="inline-flex align-top" data-testid="merchandise-date-picker">
                    <DatePickerPopover
                        shouldShowMonthSelector
                        classNames={{ popover: "p-3" }}
                        pickerType="day"
                        value={date.toDate()}
                        onChange={handleDateChange}
                    >
                        <div className="flex h-8 cursor-pointer items-center space-x-2 rounded border border-gray-light p-3">
                            <CalendarIcon size="medium" />
                            <span>{dateValue}</span>
                            <DownArrowIcon size="medium" />
                        </div>
                    </DatePickerPopover>
                </div>

                <ListFilter
                    label="Merchandise"
                    title="Filter Merchandise"
                    localize={false}
                    collection={[MERCHANDISE_API_PATH]}
                    value={filters.merchandise}
                    onChange={(merchandise) => setFilters({ merchandise })}
                />

                <ListFilter
                    label="Fulfillment Status"
                    title="Filter Fulfillment Status"
                    localize={false}
                    fetch={() => ({
                        data: fulfillmentStatusOptions
                            .filter((opt) => opt.key !== MerchandiseDashboardFulfillmentFilter.ALL)
                            .map((opt) => ({ id: opt.key, name: opt.label })),
                        isLoading: false,
                        hasNextPage: false,
                        isFetchingNextPage: false,
                    })}
                    value={filters.fulfillmentStatus}
                    onChange={(fulfillmentStatus) => setFilters({ fulfillmentStatus })}
                />
            </div>
        </div>
    );
};

const fulfillmentStatusOptions = [
    { key: MerchandiseDashboardFulfillmentFilter.ALL, label: "All" },
    { key: MerchandiseDashboardFulfillmentFilter.FULFILLED, label: "Fulfilled" },
    { key: MerchandiseDashboardFulfillmentFilter.UNFULFILLED, label: "Unfulfilled" },
    { key: MerchandiseDashboardFulfillmentFilter.PARTIALLY_FULFILLED, label: "Partial" },
];
